<template>
  <div class="resume-conformity-progress">
    <RoundProgress
      :number="value"
      :percents="value"
      use-circle-backline
      :style="{ '--circle-stroke-color': progressColor }"
    >
      <span class="resume-conformity-progress__number">{{ value }}%</span>
    </RoundProgress>
  </div>
</template>

<script>
import RoundProgress from '../round-progress/RoundProgress';

export default {
  name: 'ResumeConformityProgress',
  components: {
    RoundProgress,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    progressColor() {
      const lvl = this.value;
      switch (true) {
        case lvl >= 80: return '#1acb61';
        case lvl >= 35: return '#f6cf17';
        default: return '#fc423b';
      }
    },
  },
};
</script>
